/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import  { Suspense,useEffect,useState,useCallback } from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import React from 'react';
import {setUserType} from '../pages/auth/authSlice'
import {Route,Navigate,Routes,useNavigate,useLocation} from 'react-router-dom';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import Layout from '../components/Layout';
import Noroute from '../components/Noroutes';
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import { dataService } from '../services/data.services';
import { resetState } from '../redux/systemConfigSlice';
import UpdatePassword from '../pages/auth/Profile/UpdatePassword.jsx';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification.jsx';
import { getAuthItem, setAuthItem } from '../CommonMethods/authSession';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

export default function NavigationRoutes(props) {
    const dispactch=useDispatch()
    const [loading, setloading] = useState(true)
    const [CurrentUser, setCurrentUser] = useState('');
    const auth=useSelector(state=>state?.auth)
    const location = useLocation();
    const restrict = useSelector((state)=>state?.systemConfigData?.restrict)
    const {loggedIn}=auth
    const duplicateSessionPending = sessionStorage.getItem('duplicate_session_pending') === 'true';
    const navigate = useNavigate()
    const fetchUserAttributes= useCallback(
  
        async() => {
            try {
                if(!auth.loggedIn && location.pathname!=='/reset-password' && location.pathname!=='/reset-new-password' && location.pathname!=='/email-address-verification'){
                    // If already on the login page ('/'), preserve existing search params (e.g. ?redirect=...)
                    // instead of double-encoding them into a new redirect parameter
                    if (location.pathname !== '/') {
                        navigate('/', { state: { from: location } })
                    }
                    setAuthItem('custom:is_first_time_login', false);

                }
                const user = await dataService.GetAPI('patients/check-status');
                const userType = user?.data?.user_type; // Get the user type attribute
                setCurrentUser(userType)
                dispactch(setUserType(userType));          
                
                setloading(false)
                // location(window.location.pathname)
            } catch (error) {
                if(getAuthItem('IdToken')){
                    const storedInfo = getAuthItem('user-info');
                    try {
                        const parsed = storedInfo ? JSON.parse(storedInfo) : {};
                        setCurrentUser(parsed?.role);
                    } catch (err) {
                        setCurrentUser('');
                    }
                }
                
                // Handle error fetching user attributes
                setloading(false)
            }
        },
        [CurrentUser],
    )
    
  
    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
   effect is triggered when there are changes to the `loggedIn`, `fetchUserAttributes`, `logout`, or
   `GlobalChange` variables. */
    useEffect(() => {
        if(!loggedIn){

            setCurrentUser('')
            dispactch(resetState())
        }
        if((CurrentUser ===undefined || CurrentUser==='')&&loggedIn){
            fetchUserAttributes();
        }
        setloading(false)
        
    
    }, [loggedIn,fetchUserAttributes]);



    
   
    return (

        <Suspense fallback={<div></div>}>{!loading &&
            <>
                <Routes location={location} key={location.pathname}>
                    <Route path='/email-address-verification' element={
                        <AnimatedPage>
                            <EmailVerificationScreen/>
                        </AnimatedPage>
                    }>

                    </Route>
                    {(!loggedIn || getAuthItem('custom:is_first_time_login') === 'true' || duplicateSessionPending) ? <>
                        <Route path="/" element={
                            <AnimatedPage><LoginPage /></AnimatedPage>} />
                        <Route path="/reset-password" element={
                            getAuthItem('custom:is_first_time_login')==="true" ? (
                                <AnimatedPage>
                                    <ResetPassword />
                                </AnimatedPage>
                            ) : (
                                <Navigate to="/" replace />
                            )} />
                        <Route path="/reset-new-password/" element={
                            <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />
                        <Route path="/404" element={
                            <>
                                <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                            </>} />  
                      
                        <Route
                            path="*"
                            element={<Navigate to="/" state={{ from: location }} replace />}
                        />
                    </>:(
                        ComponentsBasedOnRole[CurrentUser]&&
                        <Route element={<Layout {...props}/>} key={location.key}>
                            {restrict?(<><Route path={'/'} element={React.cloneElement(ComponentsBasedOnRole[CurrentUser][0].element, props)}  key={'/profile'}/><Route path={'/profile/update-password'} element={<UpdatePassword/>}  key={'/profile/update-password'}/></>):ComponentsBasedOnRole[CurrentUser]?.map((nav)=>(
                                ((CurrentUser === "patient-user" || CurrentUser==='observer')) &&
                                <Route path={nav.path} element={React.cloneElement(nav.element, props)}  key={nav.path}/>
                            ))}
                            {restrict? <Route path="*" element={<Navigate to="/" />} />:<Route
                                path="*"
                                element={
                                    <>
                                        <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                                    </>} 
                                
                            />}
                            <Route path="/404" element={
                                <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                            } />  
                        </Route>
                        
                    )
                    }
                   
                    <Route
                        path="*"
                        element={
                            <Noroute/>} 
                                
                    />
                    
                </Routes>
            </>
        }</Suspense>

    );
}